export function drawerPie(_this, myChart, data) {
/*   {
    value: v.value,
    legendname: v.name.split(reg).join(""),
    name: `${v.name.split(reg).join("")}：${v.value}`,
    itemStyle: {
      color: this.$config.chartColors[i],
    },
  } */
  var option = {
    tooltip: {
      trigger: 'item',
      formatter: function (parms) {
        var str = parms.seriesName + "</br>" +
          parms.marker + "" + parms.data.legendname + "</br>" +
          "数量：" + parms.data.value + "</br>" +
          "占比：" + parms.percent + "%";
        return str;
      }
    },
    legend: {
      type: "scroll",
      orient: 'vertical',
      right: '5%',
      align: 'left',
      top: 'middle',
      textStyle: {
        color: '#8C8C8C'
      },
    },
    series: [{
      name: '占比',
      type: 'pie',
      center: ['30%', '50%'],
      radius: ['30%', '50%'],
      label: {
        normal: {
          show: false,
        }
      },
      data: data
    }]
  }
  if(myChart)myChart.setOption(option)
}



// WEBPACK FOOTER //
// ./src/util/chartsPie.js